import { AssetSchemaRootState } from '../store';

export const assetSchemaBaseSelector = (state: AssetSchemaRootState) =>
	state.assetSchema;
